import React, { lazy } from 'react';
import { RouteProps, Navigate } from 'react-router-dom';
import { dashboardPagesMenu, authPagesMenu, subPagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';
import OktaCallback from '../pages/presentation/auth/OktaCallback';
import ProtectedRoute from '../components/ProtectedRoute';
import { ROUTER_KEYS } from '../api/modules/permission';

/**
 * 路由配置
 */

const PAGES = {
  TAG_MANAGEMENT: lazy(() => import('../pages/presentation/tag-management')),
  COPY_TAG: lazy(() => import('../pages/presentation/tag-management/copy')),
  AUDIENCE_MANAGEMENT: lazy(() => import('../pages/presentation/audience-management')),
  CREATE_AUDIENCE: lazy(() => import('../pages/presentation/audience-management/audience-create')),
  AUDIENCE_INSIGHT: lazy(
    () => import('../pages/presentation/audience-management/audience-insight'),
  ),
};

const AUTH = {
  PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};

const presentation: RouteProps[] = [
  {
    path: '/',
    element: <Navigate to={dashboardPagesMenu.tagManagement.path} replace />,
  },

  // ========== 受权限保护的业务路由（统一使用 PAGE_VIEW 权限）==========
  {
    path: dashboardPagesMenu.tagManagement.path,
    element: (
      <ProtectedRoute routerKey={ROUTER_KEYS.PAGE_VIEW}>
        <PAGES.TAG_MANAGEMENT />
      </ProtectedRoute>
    ),
  },
  {
    path: dashboardPagesMenu.audienceManagement.path,
    element: (
      <ProtectedRoute routerKey={ROUTER_KEYS.PAGE_VIEW}>
        <PAGES.AUDIENCE_MANAGEMENT />
      </ProtectedRoute>
    ),
  },
  {
    path: subPagesMenu.createAudience.path,
    element: (
      <ProtectedRoute routerKey={ROUTER_KEYS.PAGE_VIEW}>
        <PAGES.CREATE_AUDIENCE />
      </ProtectedRoute>
    ),
  },
  {
    path: subPagesMenu.copyTag.path,
    element: (
      <ProtectedRoute routerKey={ROUTER_KEYS.PAGE_VIEW}>
        <PAGES.COPY_TAG />
      </ProtectedRoute>
    ),
  },
  {
    path: dashboardPagesMenu.audienceInsight.path,
    element: (
      <ProtectedRoute routerKey={ROUTER_KEYS.PAGE_VIEW}>
        <PAGES.AUDIENCE_INSIGHT />
      </ProtectedRoute>
    ),
  },

  // Auth Pages
  {
    path: authPagesMenu.page404.path,
    element: <AUTH.PAGE_404 />,
  },
  {
    path: authPagesMenu.login.path,
    element: <Login />,
  },
  {
    path: '/implicit/callback',
    element: <OktaCallback />,
  },
];

const contents = [...presentation];

export default contents;
